"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brandingVariables = void 0;
var brandingVariables = {
  /**
   * Main Branding Colours
   */
  brandPrime: '#ed1c24',

  /**
   * Main Branding Colours
   * Colours for main screen elements
   */
  backing: '#f2f2f2',
  accent0: '#ffffff',
  accent1: '#c2c4c6',
  accent2: '#c4b3b3',
  accent3: '#77787b',
  accent4: '#575757',
  accent5: '#000000',

  /**
   * Colours for main interaction elements
   */
  interact1: '#183c73',
  interact2: '#13305b',

  /**
   * Status Colours
   */
  success: '#00b050',
  warning: '#ffb600',
  error: '#a40122',

  /**
   * Size Variables
   */
  inputHeight: '2.5rem',
  gapSmall: '0.25rem',
  gapMedium: '0.5rem',
  gapLarge: '1rem'
};
exports.brandingVariables = brandingVariables;